import type { ReactNode } from "react";

type TableContainerProps = {
  children: ReactNode;
  className?: string;
};

const TableContainer = ({ children, className }: TableContainerProps) => {
  return <div className={className ?? "overflow-x-auto rounded-xl border border-myteengig-border bg-white shadow-sm"}>{children}</div>;
};

export default TableContainer;
